import React from 'react';
import { tw } from 'twind';
import { InputSelect } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { countingNumbersAsDropdownList } from 'utils/countingNumbers';

interface QuantityDropdownProps extends React.HTMLAttributes<HTMLElement> {
  fullWidth?: boolean;
  quantity: number;
  setQuantity: (q: number) => void;
  maxQuantity?: number;
}

export const QuantityDropdown: React.FC<QuantityDropdownProps> = ({
  className,
  quantity,
  setQuantity,
  maxQuantity = 6,
}) => {
  const t = useTranslate();
  return (
    <InputSelect
      id="qty-dropdown"
      className={tw('w-[90px] mr-2', className)}
      value={quantity.toString()}
      showLabel={false}
      dataTestId="pdp-quantity-select"
      options={countingNumbersAsDropdownList(maxQuantity)}
      label={t('quantity')}
      onChange={newQty => setQuantity(Number.parseInt(newQty as string))}
      placeholder={t('qty')}
    />
  );
};
